import {Paper, Stack, Typography, Box} from '@mui/material';

import CreditCardIcon from '$assets/svgs/credit-card-x.svg?react';

import {
  amountStyle,
  descriptionStyle,
  iconContainerStyle,
  titleStyle,
} from './styles';
import {cardStyle} from '../../styles';
import {DashboardData} from '$api/finance/dashboard';

interface OutstandingInsuranceAmountsCardProps {
  data: DashboardData;
}

const OutstandingInsuranceAmountsCard: React.FC<
  OutstandingInsuranceAmountsCardProps
> = ({data}) => {
  const {unpaid_insurance_count, total_outstanding} =
    data.outstanding_insurance_amounts;

  // const {outstanding_insurance} = data;
  return (
    <Paper sx={cardStyle}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box sx={iconContainerStyle}>
          <CreditCardIcon />
        </Box>
        <Typography variant="h6" sx={titleStyle}>
          Outstanding insurance amounts
        </Typography>
      </Stack>
      <Typography variant="h2" sx={amountStyle}>
        £{total_outstanding.toLocaleString()}
      </Typography>
      <Typography color="text.secondary" mt={1}>
        in total
      </Typography>
      <Typography sx={descriptionStyle} mt={2}>
        (from {unpaid_insurance_count} pending claims)
      </Typography>
    </Paper>
  );
};

export default OutstandingInsuranceAmountsCard;
